import React, { FC } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { Card, Col, Row } from 'antd';
import { checkAndFormatPhoneNumber } from '../../utils/DataFormatterUtils';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

require('../service_provider_card_display/ServiceProviderCardDisplay.less');

const ContractorClientCardDisplay: FC<any> = ({ contractorClient }) => {
	const phoneNumbers = Array.from(
		new Set(
			[
				...(nullSafeGet('phoneNumber', contractorClient)
					? [nullSafeGet('phoneNumber', contractorClient)]
					: []),
			].map((num) => checkAndFormatPhoneNumber(num))
		)
	);
	const emails = Array.from(
		new Set([
			...(nullSafeGet('primaryContactEmail', contractorClient)
				? [nullSafeGet('primaryContactEmail', contractorClient)]
				: []),
		])
	);

	return (
		<div>
			<Card title="Client" onClick={null} hoverable={true}>
				<div className="materialCard__flexCentVert" style={{ marginBottom: 24 }}>
					<div>
						<div className="materialCard__title">{nullSafeGet('name', contractorClient)}</div>
						<AddressDisplay
							className="materialCard__subtitle"
							hidePostcode={true}
							hideCountry={true}
							hideStreetAddress={true}
							address={nullSafeGet('address', contractorClient)}
							style={{
								color: 'rgba(0,0,0,0.45)',
							}}
						/>
					</div>
				</div>
				{phoneNumbers && phoneNumbers.length && phoneNumbers.length > 0 ? (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginTop: 16, marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-phone`} />
						</div>
						<div style={{ display: 'flex', whiteSpace: 'normal', flexWrap: 'wrap' }}>
							{phoneNumbers.map((num, i, list) => (
								<div style={{ marginRight: 4 }}>
									{checkAndFormatPhoneNumber(num)}
									{list.length - 1 > i ? ',' : null}
								</div>
							))}
						</div>
					</div>
				) : null}
				{nullSafeGet('primaryContactEmail', contractorClient) ? (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-secured-letter-filled`} />
						</div>
						<Col>
							{emails.map((email) => (
								<Row wrap>{email}</Row>
							))}
						</Col>
					</div>
				) : null}
			</Card>
		</div>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
	supplierFacilityReviews: state.supplier_facility_reviews,
	supplierFacilitiesFetching: state.supplier_facilities.fetching,
	match: ownProps.match,
	history: ownProps.history,
});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps)(ContractorClientCardDisplay));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
